import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TramiteDndaService {
  private apiUrl = environment.apiUrl;
  private baseUrl = '/dnda/tramite/registrar-tramite';

  constructor(private http: HttpClient) {}

  postCrearTramiteDnda(data: FormData): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}${this.baseUrl}`, data);
  }
}
